import {customElement, query} from "lit/decorators.js";
import {ScrollableBar} from "./scrollableBar";
import {html, type PropertyValues, type TemplateResult} from "lit";
import Styles from "./contentNavigation.lit.scss";

@customElement("eop-content-navigation")
export class EopContentNavigation extends ScrollableBar {

    public static readonly styles = Styles;

    @query(".content-navigation-items")
    protected scrollableArea: HTMLElement;
    private tabs: NodeListOf<HTMLElement>;

    protected items(): HTMLElement[] {
        return Array.from(this.tabs);
    }

    public constructor() {
        super();
        this.tabs = this.querySelectorAll(".content-navigation-item");
    }

    public render(): TemplateResult {
        return html`
            <div class="content-navigation-bar reverse-background">
                <nav class="content-navigation-tabs" aria-label=${this.dictionary.translate("MSG_CONTENT_NAVIGATION")}>
                    <ul class="content-navigation-items horizontally-scrollable-area"
                        @scroll=${this.toggleScrollButtonVisibility}
                        @touchend=${{handleEvent: () => this.toggleScrollButtonVisibility(), passive: true}}>
                        <li aria-hidden="true">
                            <eop-swipe-hint></eop-swipe-hint>
                        </li>
                        ${this.renderItems()}
                    </ul>
                    ${this.renderScrollLeftButton()}
                    ${this.renderScrollRightButton()}
                </nav>
            </div>
        `;
    }

    private renderItems(): TemplateResult[] {
        return this.items().map((item) => {
            return html`${item}`;
        });
    }

    protected firstUpdated(_changedProperties: PropertyValues): void {
        super.firstUpdated(_changedProperties);
        this.scrollToItem(this.activeTabIndex());
    }

    private activeTabIndex(): number {
        for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].querySelector(".active")) {
                return i;
            }
        }
        return 0;
    }
}